module.exports = __webpack_public_path__ + "img/GBM1_Endothelial.0a498d2e.png";